import { take, put } from 'redux-saga/effects'

import * as ErrorActions from 'Redux/Actions/ErrorActions'

export default function* ErrorSaga() {
  while (true) {
    const { error, payload } = yield take('*')
    if (error) {
      const { name } = payload
      if (name === 'AbortError') {
        yield put(ErrorActions.apiTimeoutError())
      }
    }
  }
}
